import React, { memo, useCallback } from 'react';
import { TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text } from '@redlink/components/atoms';

export const PreviewTabBarItem = memo(
  ({ route, index, state, descriptors, navigation }) => {
    const { styles, colors } = useStyle();
    const { options } = descriptors[route.key];
    const label =
      options.tabBarLabel !== undefined
        ? options.tabBarLabel
        : options.title !== undefined
        ? options.title
        : route.name;
    const isFocused = state.index === index;
    const icon = options.tabBarIcon
      ? options.tabBarIcon({
          size: 24,
          isFocused,
          color: isFocused ? colors.primary : colors.title,
        })
      : null;
    const onPress = useCallback(() => {
      const event = navigation.emit({
        type: 'tabPress',
        target: route.key,
        canPreventDefault: true,
      });

      if (!isFocused && !event.defaultPrevented) {
        navigation.navigate(route.name);
      }
    }, [navigation, route, isFocused]);

    const onLongPress = useCallback(() => {
      navigation.emit({
        type: 'tabLongPress',
        target: route.key,
      });
    }, [navigation, route]);

    return (
      <TouchableOpacity
        onPress={onPress}
        onLongPress={onLongPress}
        activeOpacity={0.6}
        style={styles.container}
      >
        {icon}
        <Text style={[styles.text, isFocused && { color: colors.primary }]}>
          {label}
        </Text>
      </TouchableOpacity>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  container: {
    flex: 1,
    alignItems: 'center',
  },
  text: {
    color: colors.title,
    fontSize: 10,
  },
}));
